import gql from 'graphql-tag'
import { standardArticleResult } from '../fragments'

// export const SearchQuery = gql`
// 	mutation search($data: String!) {
// 		search(search_text: $data) {
// 			edges{node{article {
// 				...standardArticleResult
// 			}
// 			company {
// 				id
// 				name
// 				slug
// 				dateFounded
// 				industry {
// 					id
// 					key
// 				}
// 				hasLogo
// 				logoPath
// 				hasCover
// 				coverPath
// 				featuredVideo
// 			}
// 			user {
// 				id
// 				uid
// 				profileCollection {edges{node{
// 					id
// 					firstName
// 					lastName
// 					hasAvatar
// 					avatarPath
// 					worksAt {
// 						id
// 						company
// 						position
// 					}
// 				}}}
// 			}
// 			team {
// 				id
// 				name
// 				slug
// 				company {
// 					id
// 					name
// 					slug
// 				}
// 			}
// 			job {
// 				id
// 				slug
// 				description
// 				title
// 				contractType
// 				seniorityLevel
// 				jobType
// 				locationType
// 				featuredImage
// 				company {
// 					id
// 					logoPath
// 					hasCover
// 					hasLogo
// 					name
// 					slug
// 					description
// 					coverPath
// 					featuredVideo
// 					industry {
// 						id
// 						key
// 					}
// 				}
// 				_TeamToJob {
// 					edges{node{
// 						job {
// 	id
// 					currency
// 					amountMin
// 					amountMax
// 					rate
// 					}}}
// _JobToCompanyOffices {edges{node{
// 	companyOffices {
// 		id
// 		roLocations {
// 			id
// 			name
// 			region2
// 		}
// 	}
// }}}
// 				# salary {
// 				# 	id
// 				# 	currency
// 				# 	amountMin
// 				# 	amountMax
// 				# 	rate
// 				# }
// 				# locations {
// 				# 	id
// 				# 	location {
// 				# 		id
// 				# 		name
// 				# 		region2
// 				# 	}
// 				# }
// 			}
// 			# CompaniesCount
// 			# ArticlesCount
// 			# PeopleCount
// 			# TeamsCount
// 			# JobsCount
// 		}}}
// 	}
// 	${standardArticleResult}
// `
export const SearchQuery = gql`
	query search($data: String!) {
		search(data: $data) {
			edges {
				node {
					article {
						...standardArticleResult
					}
					company {
						id
						name
						slug
						dateFounded
						industry {
							id
							key
						}
						hasLogo
						logoPath
						hasCover
						coverPath
						featuredVideo
					}
					user {
						id
						uid
						profileCollection {
							edges {
								node {
									id
									firstName
									lastName
									hasAvatar
									avatarPath
									experienceCollection {
										edges {
											node {
												position
												company
											}
										}
									}
									#   worksAt {
									#     id
									#     company
									#     position
									#   }
								}
							}
						}
					}
					team {
						id
						name
						slug
						company {
							id
							name
							slug
						}
					}
					job {
						id
						slug
						description
						title
						contractType
						seniorityLevel
						jobType
						locationType
						featuredImage
						company {
							id
							logoPath
							hasCover
							hasLogo
							name
							slug
							description
							coverPath
							featuredVideo
							industry {
								id
								key
							}
						}
						_TeamToJobCollection {
							edges {
								node {
									job {
										jobSalary {
											id
											currency
											amountMin
											amountMax
											rate
										}
									}
								}
							}
						}
						_JobToCompanyOfficesCollection {
							edges {
								node {
									companyOffices {
										id
										roLocations {
											id
											name
											region2
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	${standardArticleResult}
`

export const SearchPeopleQuery = gql`
	query profileCollection($offset: Int!, $filter: ProfileFilter) {
		profileCollection(offset: $offset, filter: $filter) {
			edges {
				node {
					id
					firstName
					lastName
					hasAvatar
					avatarPath
					experienceCollection {
						edges {
							node {
								position
								company
							}
						}
					}
					# worksAt {
					# 	id
					# 	company
					# 	position
					# }
				}
			}
			pageInfo {
				hasNextPage
			}
		}
	}
`

export const SearchArticlesQuery = gql`
	query searchArticles($offset: Int!, $query: String) {
		articleCollection(
			first: 10
			offset: $offset
			orderBy: { createdAt: DescNullsLast, updatedAt: DescNullsLast }
			filter: {
				or: [
					{ title: { ilike: $query } }
					{ description: { ilike: $query } }
					{ body: { ilike: $query } }
				]
			}
		) {
			edges {
				node {
					...standardArticleResult
				}
			}
			pageInfo {
				hasNextPage
			}
		}
	}

	${standardArticleResult}
`
// export const SearchCompaniesQuery = gql`
// 	query searchCompanies($data: SearchCompaniesInput) {
// 		searchCompanies(data: $data) {
// 			...standardCompanyResult
// 		}
// 	}
// 	${standardCompanyResult}
// `
// export const SearchTeamsQuery = gql`
// 	query searchTeams($data: SearchTeamsInput) {
// 		searchTeams(data: $data) {
// 			...standardTeamResult
// 		}
// 	}
// 	${standardTeamResult}
// `
